var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-page-layout',_vm._b({staticClass:"page-accessories"},'app-page-layout',_vm.content,false),[_c('div',{staticClass:"page-accessories__accessories"},_vm._l((_vm.content.data),function(accessory,index){return _c('app-accessory-block',{key:index,attrs:{"accessory":accessory}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }